import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  const pageTitle = category
    ? `${category.name} - 黑料视频 | 国产黑料视频实时追踪`
    : '分类页 - 黑料视频';
  const pageDesc = category
    ? `${category.description}。黑料视频${category.name}频道，实时更新最新${category.name}内容，吃瓜不迷路。`
    : '黑料视频分类浏览，明星黑料、网红爆料、社会热点、综艺吃瓜一站式浏览。';

  useEffect(() => {
    document.title = pageTitle;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', pageDesc);
  }, [pageTitle, pageDesc]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-heading font-bold text-foreground-900">分类未找到</h2>
          <Link to="/" className="mt-4 inline-block text-primary-600 hover:underline">返回首页</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden mx-auto mt-6 md:mt-8" style={{ maxWidth: 'calc(100% - 48px)' }}>
        <div className="absolute inset-0 rounded-[28px] overflow-hidden">
          <img
            src={category.imageUrl}
            alt={`${category.name} - 黑料视频`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70 rounded-[28px]"></div>
        </div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6 w-full">
          <span className="px-4 py-1.5 rounded-full border border-white/40 text-white text-sm font-medium mb-5 backdrop-blur-sm whitespace-nowrap">
            {category.name}
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white">{category.name}</h1>
          <p className="mt-4 text-sm md:text-base text-white/75 max-w-xl">{category.description}</p>
        </div>
      </section>

      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: category.name },
        ]}
      />

      <main className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            <a href="#cat-articles">共 {articles.length} 条{category.name}爆料</a>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 黑料视频在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500 flex-wrap">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded whitespace-nowrap">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}